
(function importProcessModuleDefinition() {

    'use strict';
    
    angular.module('ImportProcess', ['ui.router', 'Config', 'Entities','ClickOnce'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function importProcessConfig(config, $stateProvider, loginProvider) {
                     
                $stateProvider.state('import-process-find', {
                    url: "/ImportProcess/List",
                    templateUrl: config.resourceUrl('/views/import-process/list.html'),
                    controller: 'ImportProcessFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('IMPORTPROCESS READ').or('IMPORTPROCESS WRITE')
                });

                $stateProvider.state('import-process-add', {
                    url: "/ImportProcess/Add",
                    templateUrl: config.resourceUrl('/views/import-process/add.html'),
                    controller: 'ImportProcessAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('IMPORTPROCESS WRITE')
                });

                $stateProvider.state('import-process-detail', {
                    url: '/ImportProcess/Detail/{id}',
                    templateUrl: config.resourceUrl('/views/import-process/detail.html'),
                    controller: 'ImportProcessDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('IMPORTPROCESS READ').or('IMPORTPROCESS WRITE')
                });
            }
        ]);
})();